import { render, staticRenderFns } from "./AxNavbar.vue?vue&type=template&id=2daf45e2&"
import script from "./AxNavbar.vue?vue&type=script&lang=ts&"
export * from "./AxNavbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2daf45e2')) {
      api.createRecord('2daf45e2', component.options)
    } else {
      api.reload('2daf45e2', component.options)
    }
    module.hot.accept("./AxNavbar.vue?vue&type=template&id=2daf45e2&", function () {
      api.rerender('2daf45e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/AxNavbar.vue"
export default component.exports